/**
 * 메일 서버 설정
 *
 * @since 2018-10-05
 * @author jupil.Go <devp018>
 */

import {i18n} from '~/plugins/i18n'
import {CmApiPrefix as apiPrefix} from '~/utils/restApi'

const initReportPageData = () => {
  return {
    device_list: [],
    // report_cm_id: 0, // void 0
    report_cm_sync_yn: 1,
    report_cm_uname: '',
    report_cm_desc: '',

    report_cm_common_sync_yn: 0,
    report_cm_common_save_term: 0,
    report_cm_common_lang_type: 1,

    report_cm_sched_sync_yn: 0,
    report_cm_sched_hour: 1,
    report_cm_sched_min: 0,
    report_cm_sched_day_use_yn: 0,
    report_cm_sched_day_hour: 0,
    report_cm_sched_day_min: 0,
    report_cm_sched_week_use_yn: 0,
    report_cm_sched_week_this_week_use_yn: 1,
    report_cm_sched_week_start_type: 1,
    report_cm_sched_week_end_type: 7,
    report_cm_sched_week_hour: 0,
    report_cm_sched_week_min: 0,
    report_cm_sched_week_type: 1,
    report_cm_sched_month_use_yn: 0,
    report_cm_sched_month_hour: 0,
    report_cm_sched_month_min: 0,
    report_cm_sched_month_type: 1,
    report_cm_device_model_type: 20,

    report_cm_send_sync_yn: 0,
    report_cm_send_hour: 1,
    report_cm_send_min: 0,

    report_cm_send_server: []
  }
}

const initAutoSendData = (ccFlag = 0) => {
  return {
    // report_cm_id: 0, // void 0
    // report_cm_send_server_id: 0, // void 0
    report_cm_send_server_use_yn: 0,
    report_cm_send_server_type: 0,
    report_cm_send_server_prtc_type: ccFlag ? 1 : 0, // 0:ftp, 1: sftp,
    report_cm_send_server_addr_val: '',
    report_cm_send_server_port: ccFlag ? 22 : 21,
    report_cm_send_server_recver_email: null,
    report_cm_send_server_sender_email: null,
    report_cm_send_server_auth_use_yn: 0,
    report_cm_send_server_enc_use_yn: 0,
    report_cm_send_server_login_name: '',
    report_cm_send_server_login_pw: '',
    report_cm_send_server_dir_val: ''
  }
}

export const state = () => ({
  url: `${apiPrefix}/report-cm`,
  reportDataList: [],
  reportPageData: initReportPageData(),
  selectedSendItems: {},
  autoSendData: initAutoSendData(),
  backupAutoSendData: {}
})

export const mutations = {
  // 리스트 조회
  setReportData (state, data) {
    state.reportDataList = data
  },
  addReport (state, item) {
    state.reportDataList.push(item)
  },
  delReport (state, itemList) {
    for (const itemKey of itemList.report_cm_id_list) {
      const idx = _.findIndex(state.reportDataList, {report_cm_id: itemKey})
      if (idx >= 0) {
        state.reportDataList.splice(idx, 1)
      }
    }
  },
  setReportDialog (state, data) {
    state.reportPageData = _.cloneDeep(data)
  },
  initAllState (state) {
    state.reportDataList = []
    state.reportPageData = initReportPageData()
    state.selectedSendItems = {}
    state.autoSendData = initAutoSendData()
    state.backupAutoSendData = {}
  },
  clearReportDialog (state) {
    state.reportPageData = initReportPageData()
  },
  setSelectedServerData (state, data) {
    state.selectedSendItems = data
  },
  clearSelectedSendItem (state) {
    state.selectedSendItems = {}
  },
  setReportPageDeviceList (state, data) {
    state.reportPageData.device_list = _.cloneDeep(data)
  },
  clearReportPageDeviceList (state) {
    state.reportPageData.device_list = []
  },
  setAutoSendDialog (state, data) {
    state.backupAutoSendData = _.cloneDeep(data)
    state.autoSendData = _.cloneDeep(data)
  },
  clearAutoSendDialog (state, ccFlag) {
    state.backupAutoSendData = {}
    state.autoSendData = initAutoSendData(ccFlag)
  },
  rollbackAutoSendData (state) {
    state.autoSendData = _.cloneDeep(state.backupAutoSendData)
  },
  addAutoSendData (state, data) {
    const reportCmSendServer = _.cloneDeep(state.reportPageData.report_cm_send_server)
    reportCmSendServer.push(data)

    state.reportPageData.report_cm_send_server = reportCmSendServer
  },
  edtAutoSendData (state, data) {
    const reportCmSendServer = _.cloneDeep(state.reportPageData.report_cm_send_server)

    let updateCmSendServer = reportCmSendServer
    if (typeof data.report_cm_send_server_id !== 'undefined') {
      updateCmSendServer = _.map(reportCmSendServer, server => {
        if (server.report_cm_send_server_id === data.report_cm_send_server_id) {
          server = _.assign(server, data)
          // server = data
        }
        return server
      })
    } else {
      const targetServerData = updateCmSendServer[state.selectedSendItems.itemIndex]
      if (typeof targetServerData !== 'undefined') {
        updateCmSendServer[state.selectedSendItems.itemIndex] = _.assign(targetServerData, data)
      }
    }

    state.reportPageData.report_cm_send_server = updateCmSendServer
  },
  delAutoSendData (state, data) {
    const reportCmSendServer = _.cloneDeep(state.reportPageData.report_cm_send_server)

    let deletedReportCmSendServer = reportCmSendServer
    if (typeof data.report_cm_send_server_id !== 'undefined') {
      deletedReportCmSendServer = _.filter(reportCmSendServer, server => {
        return server.report_cm_send_server_id !== data.report_cm_send_server_id
      })
    } else {
      deletedReportCmSendServer.splice(data.itemIndex, 1)
    }

    state.reportPageData.report_cm_send_server = deletedReportCmSendServer
  },
  checkUsingServer (state, data) {
    const reportCmSendServer = _.cloneDeep(state.reportPageData.report_cm_send_server)

    let updateServerData = reportCmSendServer
    if (typeof data.report_cm_send_server_id !== 'undefined') {
      updateServerData = _.map(reportCmSendServer, server => {
        if (server.report_cm_send_server_id === data.report_cm_send_server_id) {
          server.report_cm_send_server_use_yn = data.report_cm_send_server_use_yn
        }
        return server
      })
    } else {
      const targetServerData = updateServerData[data.itemIndex]
      if (typeof targetServerData !== 'undefined') {
        targetServerData.report_cm_send_server_use_yn = data.report_cm_send_server_use_yn
      }
    }

    state.reportPageData.report_cm_send_server = updateServerData
  },
  clearAutoSendServer (state) {
    state.reportPageData.report_cm_send_server = []
  }
}

export const actions = {
  // 리스트 조회
  async getReportData ({commit, state}, { loading = true, id = 0 } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const axiosParam = { loading }
      res = await this.$axios.$get(`${state.url}/${id}`, axiosParam)
      if (res.code === 'ok') {
        if (id === 0) { // 전체 조회
          commit('setReportData', res.result)
        } else { // 추가/편집 조회
          commit('setReportDialog', res.result[0])
        }
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addReport ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const addParam = _.pick(state.reportPageData, [
        'report_cm_sync_yn',
        'report_cm_uname',
        'report_cm_desc',
        'report_cm_common_sync_yn',
        'report_cm_common_save_term',
        'report_cm_common_lang_type',
        'report_cm_sched_sync_yn',
        'report_cm_sched_hour',
        'report_cm_sched_min',
        'report_cm_sched_day_use_yn',
        'report_cm_sched_day_hour',
        'report_cm_sched_day_min',
        'report_cm_sched_week_use_yn',
        'report_cm_sched_week_this_week_use_yn',
        'report_cm_sched_week_start_type',
        'report_cm_sched_week_end_type',
        'report_cm_sched_week_hour',
        'report_cm_sched_week_min',
        'report_cm_sched_week_type',
        'report_cm_sched_month_use_yn',
        'report_cm_sched_month_hour',
        'report_cm_sched_month_min',
        'report_cm_sched_month_type',
        'report_cm_send_sync_yn',
        'report_cm_send_hour',
        'report_cm_send_min',
        'report_cm_device_model_type',
        'report_cm_send_server'
      ])

      addParam.device_id_list = _.map(state.reportPageData.device_list, 'device_id')
      res = await this.$axios.$post(state.url, addParam, {loading: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async edtReport ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const param = _.pick(state.reportPageData, [
        'report_cm_id',
        'report_cm_sync_yn',
        'report_cm_uname',
        'report_cm_desc',
        'report_cm_common_sync_yn',
        'report_cm_common_save_term',
        'report_cm_common_lang_type',
        'report_cm_sched_sync_yn',
        'report_cm_sched_hour',
        'report_cm_sched_min',
        'report_cm_sched_day_use_yn',
        'report_cm_sched_day_hour',
        'report_cm_sched_day_min',
        'report_cm_sched_week_use_yn',
        'report_cm_sched_week_this_week_use_yn',
        'report_cm_sched_week_start_type',
        'report_cm_sched_week_end_type',
        'report_cm_sched_week_hour',
        'report_cm_sched_week_min',
        'report_cm_sched_week_type',
        'report_cm_sched_month_use_yn',
        'report_cm_sched_month_hour',
        'report_cm_sched_month_min',
        'report_cm_sched_month_type',
        'report_cm_send_sync_yn',
        'report_cm_send_hour',
        'report_cm_send_min',
        'report_cm_device_model_type',
        'report_cm_send_server'
      ])

      param.device_id_list = _.map(state.reportPageData.device_list, 'device_id')

      res = await this.$axios.$put(state.url, param)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async delReport ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const isShow = _.has(param, 'isShow') ? param.isShow : true
      const isAlert = _.has(param, 'isAlert') ? param.isAlert : true

      res = await this.$axios.$put(`${state.url}/multi`, param.idList, {
        loading: isShow,
        successAlert: isAlert,
        alertMsg: i18n.t('msg.removeApply')
      })
      if (res.code === 'ok') {
        commit('delReport', param.idList)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async processReportSync ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      res = await this.$axios.$post(`${state.url}/multi`, param, {loading: false, isNotAlert: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async finalCommand ({state}, type) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const axiosConfig = (type === 'apply') ? {applyMsg: true} : {cancelMsg: true}
      res = await this.$axios.$put(`${state.url}/${type}`, void 0, axiosConfig)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 리스트 조회
  async getAutoSendData ({commit, state}) {
    const res = {
      code: 'ok',
      result: {}
    }

    try {
      commit('setAutoSendDialog', state.selectedSendItems) // 선택된 데이터
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addAutoSendData ({commit, dispatch, state, rootState}, param) {
    const res = {
      code: 'ok',
      result: {}
    }

    try {
      const addParam = _.cloneDeep(state.autoSendData)
      if (param.password.length !== 0) {
        addParam.report_cm_send_server_login_pw = param.password
      } else {
        addParam.report_cm_send_server_login_pw = null
      }
      delete addParam.report_cm_send_server_id

      commit('addAutoSendData', addParam)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async edtAutoSendData ({commit, state}, param) {
    const res = {
      code: 'ok',
      result: {}
    }

    try {
      const edtParam = _.cloneDeep(state.autoSendData)
      if (param.password.length !== 0) {
        edtParam.report_cm_send_server_login_pw = param.password
      } else {
        delete edtParam.report_cm_send_server_login_pw
      }
      commit('edtAutoSendData', edtParam)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async delAutoSendData ({commit, state}) {
    const res = {
      code: 'ok',
      result: {}
    }

    try {
      if (!_.isEmpty(state.selectedSendItems)) {
        commit('delAutoSendData', {
          itemIndex: state.selectedSendItems.itemIndex,
          report_cm_send_server_id: state.selectedSendItems.report_cm_send_server_id
        })
        commit('clearSelectedSendItem')
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async checkUsingServer ({commit, state}, param) {
    const res = {
      code: 'ok',
      result: {}
    }

    try {
      if (!_.isEmpty(param)) {
        commit('checkUsingServer', param)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {}

export const strict = false
